//region :: Imports ::
import React, {ReactElement, ReactNode} from 'react';
import MComponent from '../../Toolkit/Components/Component';
import {MCancelIconName, MIcon, MOkIconName} from '../../Toolkit/Icons';
import {DialogPositionType} from 'primereact/dialog';
import Dialog from '../../Toolkit/Components/Controls/Dialog';
import MButton from '../../Toolkit/Components/Controls/Button';
import {UploadIconName} from '../SafeDigConstants';
import MTextArea, {MInputAreaValueType} from '../Components/TextArea';

//endregion

/** */
type Props = {}

/** */
type State = {
    position?: DialogPositionType;
    visible: boolean;
    noteText: string;
    onAddNote?: (data: string) => void;
    uploading: boolean;
}

/** */
class NoteDialog extends MComponent<Props, State> {

    private UploadIcon: MIcon = {name: UploadIconName, color: 'mcolor-info'};

    /** */
    public constructor(props: Props) {
        super(props);

        this.bindMethods();
        this.initializeState();
    }

    /** */
    private bindMethods(): void {
        this.dialog_onHide = this.dialog_onHide.bind(this);

        this.getDialogTemplate = this.getDialogTemplate.bind(this);
        this.getFooterTemplate = this.getFooterTemplate.bind(this);
        this.ok_Click = this.ok_Click.bind(this);
        this.onNoteChange = this.onNoteChange.bind(this);

        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
    }

    /** */
    private initializeState(): void {
        this.state = {
            visible: false,
            noteText: '',
            uploading: false
        };
    }

    /** */
    private dialog_onHide(): void {
        this.safeSetState((draft: State) => draft.visible = false);
    }

    /** */
    public show(inputCallback: (data: string) => void, position?: DialogPositionType) {
        this.safeSetState((draft: State) => {
            draft.position = position;
            draft.visible = true;
            draft.uploading = false;
            draft.onAddNote = inputCallback;
        });
    }

    public hide() {
        this.safeSetState((draft: State) => {
            draft.visible = false;
        });
    }

    private async ok_Click() {
        if(!this.state.uploading) {
            this.safeSetState((draft: State) => draft.uploading = true);
            await this.state.onAddNote!(this.state.noteText!);
            this.hide();
        }
    }

    private getDialogTemplate(): ReactNode {
        return (
            <div className="formgrid grid">
                <MTextArea id={'noteText'}
                           maxLength={10000}
                           disabled={false}
                           initialValue={''}
                           autoResize={true}
                           cols={80}
                           rows={10}
                           onChange={this.onNoteChange}
                />
            </div>);
    }

    private getFooterTemplate(): ReactNode {
        return (
            <div>
                <MButton label="OK"
                         color="success"
                         icon={MOkIconName}
                         disabled={!this.isUploadAvailable()}
                         onClick={this.ok_Click}/>
                <MButton label="Cancel"
                         icon={MCancelIconName}
                         disabled={false}
                         onClick={this.hide}/>
            </div>
        );
    }

    private onNoteChange(newValue: MInputAreaValueType) {
        this.safeSetState(
            (draft: State) => draft.noteText = newValue.toString());
    }

    private isUploadAvailable() {
        return this.state.noteText?.length > 0 &&
            !this.state.uploading;
    }

    /** */
    public render(): ReactElement {

        return (
            <Dialog title={'Add a new note'}
                    content={this.getDialogTemplate()}
                    icon={this.UploadIcon}
                    footer={this.getFooterTemplate()}
                    position={this.state.position}
                    canClose={false}
                    closeOnEscape={false}
                    visible={this.state.visible}
                    onHide={this.dialog_onHide}/>
        );

    }

}

export default NoteDialog;
